var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("brick-octagon-base", {
    scopedSlots: _vm._u([
      {
        key: "icon",
        fn: function() {
          return [_c(_vm.iconSvg, { tag: "component" })]
        },
        proxy: true
      },
      {
        key: "content-bottom",
        fn: function() {
          return [
            _c("div", { staticClass: "brick-title" }, [
              _vm._v("\n            " + _vm._s(_vm.displayName) + "\n        ")
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }